import { Injectable } from '@angular/core';
import { CreditCardProcessingMethod } from '../credit-card-processing-method.enum';

@Injectable({
    providedIn: 'root',
})
export class CreditCardProcessingService {
    constructor() {}

    public getCreditCardProcessingMethod(): CreditCardProcessingMethod | null {
        const method = localStorage.getItem('Credit_Card_Processing_Method');
        if (
            !method ||
            method === 'null' ||
            method === 'undefined' ||
            method === ''
        ) {
            return null;
        }
        return parseInt(method, 10) as CreditCardProcessingMethod;
    }
}
